import type { CashierLabels } from "./types";

export const trCashierLabels: CashierLabels = {
  session: {
    openedBy: "Kasiyer",
    openedAt: "Açılış",
    duration: "Süre",
    ordersCount: "İşlem",
    gross: "Ciro",
    cash: "Nakit",
    closeSession: "Kasayı Kapat",
    closeConfirm: "Kasayı kapatmak istediğinden emin misin?",
    warnLongOpen: "Kapatmayı unuttun mu?",
    parkedCount: "Park edilmiş",
    openParked: "Park edilmiş siparişler",
  },
  catalog: {
    searchPlaceholder: "Ürün, hizmet veya SKU ara…",
    noResults: "Eşleşen ürün bulunamadı",
    emptyCategory: "Bu kategoride ürün yok",
    stockLow: "Az stok",
    outOfStock: "Stokta yok",
    favorites: "Favoriler",
    allCategory: "Tümü",
    addedToCart: "Sepete eklendi",
  },
  categories: {
    grooming: "Kuaför",
    boarding: "Pansiyon",
    product: "Ürün",
    training: "Eğitim",
    vet: "Veteriner",
    walk: "Yürüyüş",
    accessory: "Aksesuar",
    consultation: "Danışma",
  },
  cart: {
    title: "Sepet",
    emptyTitle: "Sepet boş",
    emptyDescription: "Katalogdan ürün veya hizmet seç.",
    customerPick: "Müşteri seç",
    customerPickHint: "Misafir satış için boş bırak",
    petPick: "Evcil hayvan",
    guest: "Misafir",
    qtyIncrement: "Adet artır",
    qtyDecrement: "Adet azalt",
    remove: "Kaldır",
    removeConfirm: "Bu satırı kaldır?",
    addNote: "Not ekle",
    lineDiscount: "Satır indirimi",
    orderDiscount: "Sipariş indirimi",
    subtotal: "Ara Toplam",
    discount: "İndirim",
    tax: "KDV",
    total: "TOPLAM",
    park: "Park Et",
    parkPrompt: "Etiket (örn. Jack · Grooming)",
    resumeParked: "Devam Et",
    void: "İptal",
    voidConfirm: "Siparişi iptal etmek istediğinden emin misin?",
    voidReasonPrompt: "İptal sebebi",
    pay: "Ödeme Al",
    payDisabledEmpty: "Sepet boş",
    payDisabledSessionClosed: "Seans kapalı",
  },
  discount: {
    title: "İndirim Uygula",
    presetLoyalty10: "%10 Sadakat",
    presetEmployee15: "%15 Çalışan",
    presetManual: "Manuel",
    reasonPrompt: "Sebep kodu",
    apply: "Uygula",
    clear: "Temizle",
  },
  tender: {
    title: "Ödeme Yöntemi",
    remaining: "Kalan",
    overPayment: "Para Üstü",
    cash: "Nakit",
    card: "Kart",
    giftCard: "Hediye Kartı",
    loyaltyPoints: "Sadakat Puanı",
    transfer: "Havale",
    onAccount: "Hesaba",
    cashReceived: "Alınan Tutar",
    changeDue: "Para Üstü",
    addTender: "Ödeme Ekle",
    commit: "Ödemeyi Onayla",
    reference: "Referans",
    last4: "Son 4 Hane",
    commitSuccess: "Ödeme alındı",
  },
  keypad: { enter: "Tamam", clear: "Sil", backspace: "Geri" },
  parked: {
    title: "Park Edilmiş Siparişler",
    resume: "Devam Et",
    void: "İptal Et",
    empty: "Park edilmiş sipariş yok",
    meta: "{count} ürün · ₺{total}",
    label: "Etiket",
    unnamed: "Adsız sipariş",
  },
  states: {
    loading: "Yükleniyor…",
    errorTitle: "Bir şeyler ters gitti",
    errorDescription: "Bağlantıyı kontrol et ve tekrar dene.",
    errorRetry: "Tekrar Dene",
    sessionClosedTitle: "Seans Kapalı",
    sessionClosedDescription: "Yeni satış için yöneticinden seans açmasını iste.",
  },
  receipt: { print: "Fişi Yazdır", email: "E-posta Gönder", skip: "Atla" },
  currencyPrefix: "₺",
};

export const enCashierLabels: CashierLabels = {
  session: {
    openedBy: "Cashier",
    openedAt: "Opened",
    duration: "Duration",
    ordersCount: "Orders",
    gross: "Gross",
    cash: "Cash",
    closeSession: "Close Session",
    closeConfirm: "Close cash session?",
    warnLongOpen: "Forgot to close?",
    parkedCount: "Parked",
    openParked: "Parked orders",
  },
  catalog: {
    searchPlaceholder: "Search product, service or SKU…",
    noResults: "No items match",
    emptyCategory: "No items in this category",
    stockLow: "Low stock",
    outOfStock: "Out of stock",
    favorites: "Favorites",
    allCategory: "All",
    addedToCart: "Added to cart",
  },
  categories: {
    grooming: "Grooming",
    boarding: "Boarding",
    product: "Product",
    training: "Training",
    vet: "Vet",
    walk: "Walk",
    accessory: "Accessory",
    consultation: "Consultation",
  },
  cart: {
    title: "Cart",
    emptyTitle: "Cart is empty",
    emptyDescription: "Pick a product or service from the catalog.",
    customerPick: "Pick customer",
    customerPickHint: "Leave empty for guest sale",
    petPick: "Pet",
    guest: "Guest",
    qtyIncrement: "Increase qty",
    qtyDecrement: "Decrease qty",
    remove: "Remove",
    removeConfirm: "Remove this line?",
    addNote: "Add note",
    lineDiscount: "Line discount",
    orderDiscount: "Order discount",
    subtotal: "Subtotal",
    discount: "Discount",
    tax: "VAT",
    total: "TOTAL",
    park: "Park",
    parkPrompt: "Label (e.g. Jack · Grooming)",
    resumeParked: "Resume",
    void: "Void",
    voidConfirm: "Void this order?",
    voidReasonPrompt: "Void reason",
    pay: "Take Payment",
    payDisabledEmpty: "Cart empty",
    payDisabledSessionClosed: "Session closed",
  },
  discount: {
    title: "Apply Discount",
    presetLoyalty10: "10% Loyalty",
    presetEmployee15: "15% Employee",
    presetManual: "Manual",
    reasonPrompt: "Reason code",
    apply: "Apply",
    clear: "Clear",
  },
  tender: {
    title: "Payment Method",
    remaining: "Remaining",
    overPayment: "Change",
    cash: "Cash",
    card: "Card",
    giftCard: "Gift Card",
    loyaltyPoints: "Loyalty Points",
    transfer: "Transfer",
    onAccount: "On Account",
    cashReceived: "Amount Received",
    changeDue: "Change Due",
    addTender: "Add Payment",
    commit: "Confirm Payment",
    reference: "Reference",
    last4: "Last 4",
    commitSuccess: "Payment received",
  },
  keypad: { enter: "Enter", clear: "Clear", backspace: "Back" },
  parked: {
    title: "Parked Orders",
    resume: "Resume",
    void: "Void",
    empty: "No parked orders",
    meta: "{count} items · ₺{total}",
    label: "Label",
    unnamed: "Unnamed order",
  },
  states: {
    loading: "Loading…",
    errorTitle: "Something went wrong",
    errorDescription: "Check connection and try again.",
    errorRetry: "Retry",
    sessionClosedTitle: "Session Closed",
    sessionClosedDescription: "Ask your manager to open a new session.",
  },
  receipt: { print: "Print Receipt", email: "Send by Email", skip: "Skip" },
  currencyPrefix: "₺",
};
